import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ebe9f1;
  padding: 15px 0;
  background-color: white;
  border-radius: 5px;
  margin-bottom: 10px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  color: grey;
  font-weight: bold;
`;

export const Col = styled.div`
  min-width: 200px;
  padding: 0 16px;
  color: #6e6b7b;
`;

export const Table = styled.div`
  height: 800px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f0f0;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #f26934;
    border-radius: 4px;
    border: 2px solid #f0f0f0;
  }

  scrollbar-color: #f26934 #f0f0f0;
  scrollbar-width: thin;
`;
